import brandLoop from '../assets/brand-loop.png';

/**
 * SwingReplay™ wherever it is opened from - Home, Tools, a coach's lesson -
 * with Matthew's loop before the name (25 October). The loop is decoration:
 * the name beside it is what a screen reader reads.
 */
export function SwingReplayName() {
  return (
    <span className="swing-replay-name">
      <img src={brandLoop} alt="" width={39} height={20} />
      SwingReplay™
    </span>
  );
}
